// extracted by mini-css-extract-plugin
module.exports = {"height":"battery-statistics_height_3y9IW"};